import { render, staticRenderFns } from "./StocksViewStocksList.vue?vue&type=template&id=fafbbfa6"
import script from "./StocksViewStocksList.vue?vue&type=script&lang=js"
export * from "./StocksViewStocksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports